/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Posts_Specialtitle1Inputs */

const id_misc_posts_specialtitle1 = /** @type {(inputs: Misc_Posts_Specialtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🌟 Apa yang Membuat Game Ini Spesial?`)
};

const ms_misc_posts_specialtitle1 = /** @type {(inputs: Misc_Posts_Specialtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🌟 Apa yang Menjadikan Permainan Ini Istimewa?`)
};

const da_misc_posts_specialtitle1 = /** @type {(inputs: Misc_Posts_Specialtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🌟 Hvad Gør Dette Spil Specielt?`)
};

const de_misc_posts_specialtitle1 = /** @type {(inputs: Misc_Posts_Specialtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🌟 Was macht dieses Spiel besonders?`)
};

const en_us2_misc_posts_specialtitle1 = /** @type {(inputs: Misc_Posts_Specialtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🌟 What Makes This Game Special?`)
};

const es_es2_misc_posts_specialtitle1 = /** @type {(inputs: Misc_Posts_Specialtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🌟 ¿Qué hace especial a este juego?`)
};

const es_mx2_misc_posts_specialtitle1 = /** @type {(inputs: Misc_Posts_Specialtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🌟 ¿Qué hace especial a este juego?`)
};

const fil_misc_posts_specialtitle1 = /** @type {(inputs: Misc_Posts_Specialtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ano ang Nagpapaspesyal sa Larong Ito?`)
};

const fr_misc_posts_specialtitle1 = /** @type {(inputs: Misc_Posts_Specialtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🌟 Qu'est-ce qui rend ce jeu spécial ?`)
};

const it_misc_posts_specialtitle1 = /** @type {(inputs: Misc_Posts_Specialtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa rende speciale questo gioco?`)
};

const hu_misc_posts_specialtitle1 = /** @type {(inputs: Misc_Posts_Specialtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitől különleges ez a játék?`)
};

const nl_misc_posts_specialtitle1 = /** @type {(inputs: Misc_Posts_Specialtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat maakt deze game bijzonder?`)
};

const no_misc_posts_specialtitle1 = /** @type {(inputs: Misc_Posts_Specialtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hva gjør dette spillet spesielt?`)
};

const pl_misc_posts_specialtitle1 = /** @type {(inputs: Misc_Posts_Specialtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🌟 Co czyni tę grę wyjątkową?`)
};

const pt_br2_misc_posts_specialtitle1 = /** @type {(inputs: Misc_Posts_Specialtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🌟 O que torna este jogo especial?`)
};

const pt_misc_posts_specialtitle1 = /** @type {(inputs: Misc_Posts_Specialtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🌟 O que torna este jogo especial?`)
};

const ro_misc_posts_specialtitle1 = /** @type {(inputs: Misc_Posts_Specialtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🌟 Ce face acest joc special?`)
};

const fi_misc_posts_specialtitle1 = /** @type {(inputs: Misc_Posts_Specialtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🌟 Mikä tekee tästä pelistä erityisen?`)
};

const sv_misc_posts_specialtitle1 = /** @type {(inputs: Misc_Posts_Specialtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🌟 Vad gör detta spel speciellt?`)
};

const vi_misc_posts_specialtitle1 = /** @type {(inputs: Misc_Posts_Specialtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🌟 Điều gì làm cho game này đặc biệt?`)
};

const tr_misc_posts_specialtitle1 = /** @type {(inputs: Misc_Posts_Specialtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🌟 Bu Oyunu Özel Yapan Nedir?`)
};

const cs_misc_posts_specialtitle1 = /** @type {(inputs: Misc_Posts_Specialtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🌟 Co dělá tuto hru výjimečnou?`)
};

const bg_misc_posts_specialtitle1 = /** @type {(inputs: Misc_Posts_Specialtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🌟 Какво прави тази игра специална?`)
};

const ru_misc_posts_specialtitle1 = /** @type {(inputs: Misc_Posts_Specialtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🌟 Что делает эту игру особенной?`)
};

const uk_misc_posts_specialtitle1 = /** @type {(inputs: Misc_Posts_Specialtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🌟 Що робить цю гру особливою?`)
};

const ar_misc_posts_specialtitle1 = /** @type {(inputs: Misc_Posts_Specialtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🌟 ما الذي يميز هذه اللعبة؟`)
};

const hi_misc_posts_specialtitle1 = /** @type {(inputs: Misc_Posts_Specialtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🌟 इस गेम को क्या खास बनाता है?`)
};

const th_misc_posts_specialtitle1 = /** @type {(inputs: Misc_Posts_Specialtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🌟 อะไรที่ทำให้เกมนี้พิเศษ?`)
};

const ja_misc_posts_specialtitle1 = /** @type {(inputs: Misc_Posts_Specialtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🌟 このゲームの特別な点は？`)
};

const zh_cn2_misc_posts_specialtitle1 = /** @type {(inputs: Misc_Posts_Specialtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🌟 是什么让这款游戏特别？`)
};

const zh_hant1_misc_posts_specialtitle1 = /** @type {(inputs: Misc_Posts_Specialtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是什麼讓這款遊戲特別？`)
};

const ko_misc_posts_specialtitle1 = /** @type {(inputs: Misc_Posts_Specialtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 게임의 특별한 점:`)
};

/**
* | output |
* | --- |
* | "🌟 What Makes This Game Special?" |
*
* @param {Misc_Posts_Specialtitle1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_posts_specialtitle1 = /** @type {((inputs?: Misc_Posts_Specialtitle1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Posts_Specialtitle1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_posts_specialtitle1(inputs)
	if (locale === "ms") return ms_misc_posts_specialtitle1(inputs)
	if (locale === "da") return da_misc_posts_specialtitle1(inputs)
	if (locale === "de") return de_misc_posts_specialtitle1(inputs)
	if (locale === "en-US") return en_us2_misc_posts_specialtitle1(inputs)
	if (locale === "es-ES") return es_es2_misc_posts_specialtitle1(inputs)
	if (locale === "es-MX") return es_mx2_misc_posts_specialtitle1(inputs)
	if (locale === "fil") return fil_misc_posts_specialtitle1(inputs)
	if (locale === "fr") return fr_misc_posts_specialtitle1(inputs)
	if (locale === "it") return it_misc_posts_specialtitle1(inputs)
	if (locale === "hu") return hu_misc_posts_specialtitle1(inputs)
	if (locale === "nl") return nl_misc_posts_specialtitle1(inputs)
	if (locale === "no") return no_misc_posts_specialtitle1(inputs)
	if (locale === "pl") return pl_misc_posts_specialtitle1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_posts_specialtitle1(inputs)
	if (locale === "pt") return pt_misc_posts_specialtitle1(inputs)
	if (locale === "ro") return ro_misc_posts_specialtitle1(inputs)
	if (locale === "fi") return fi_misc_posts_specialtitle1(inputs)
	if (locale === "sv") return sv_misc_posts_specialtitle1(inputs)
	if (locale === "vi") return vi_misc_posts_specialtitle1(inputs)
	if (locale === "tr") return tr_misc_posts_specialtitle1(inputs)
	if (locale === "cs") return cs_misc_posts_specialtitle1(inputs)
	if (locale === "bg") return bg_misc_posts_specialtitle1(inputs)
	if (locale === "ru") return ru_misc_posts_specialtitle1(inputs)
	if (locale === "uk") return uk_misc_posts_specialtitle1(inputs)
	if (locale === "ar") return ar_misc_posts_specialtitle1(inputs)
	if (locale === "hi") return hi_misc_posts_specialtitle1(inputs)
	if (locale === "th") return th_misc_posts_specialtitle1(inputs)
	if (locale === "ja") return ja_misc_posts_specialtitle1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_posts_specialtitle1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_posts_specialtitle1(inputs)
	return ko_misc_posts_specialtitle1(inputs)
});
export { misc_posts_specialtitle1 as "misc.posts.specialTitle" }